import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { AppConfigService } from './appconfig.service';

export class IGenericSetting {
  setting: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  constructor(private httpClient: HttpClient, private appConfigService: AppConfigService) {}

  // KNP TODO Refactor the appconfigservice when have time
  getOuttageMessage(): Observable<IGenericSetting> {
    const obs = Observable.create(observer => {
      this.appConfigService.getConfiguration().subscribe(config => {
        return this.httpClient
          .post(`${config.publicApi}/Public/OuttageMessage`, {})
          .subscribe((setting: IGenericSetting) => {
            observer.next(setting);
            observer.complete();
          });
      });
    });

    return obs;
  }
}
